import React, { useState } from "react";
import "./SingleReview.scss";
import Stars from "react-stars-display";
import { MdVerifiedUser } from "react-icons/md";
import { customSubstring } from "../../helpers/customSubstring";
import { locale } from "../../translate/sweden";

const SingleReview = ({ review }) => {
  const [moreShowed, setMoreShowed] = useState(false);

  return (
    <div className="SingleReview">
      <div className="reviewFlex">
        <h2>{review.author_name}</h2>
        <p>{review.time ? review.time : locale.oneDayAgo}</p>
      </div>
      <div className="reviewFlex start">
        <Stars stars={review.rating} fill="#FDBB02" size={22} />
        <h5>
          {locale.to} {review.staff_name}
        </h5>
      </div>
      <p>{moreShowed ? review.text : customSubstring(review.text, 146)}</p>
      <div className="reviewFlex">
        <h3 onClick={() => !moreShowed && setMoreShowed(true)}>
          {!moreShowed && review.text.length > 146 && locale.showMore}
        </h3>
        <div className="verification">
          <MdVerifiedUser />
          <span>{locale.verifiedByBB}</span>
        </div>
      </div>
    </div>
  );
};

export default SingleReview;
